module.exports = __webpack_public_path__ + "img/jobtip.410e5acb.png";